import { isDefined, notDefined } from "@utils/var.check";
import PageDrawer from "./components/PageDrawer";

const Plugin = {
  instancesByName: {},
  install(app) {
    app.component("page-drawer", PageDrawer);
    const registerPageDrawer = (instance) => {
      if (notDefined(instance) || notDefined(instance.name)) {
        throw `Invalid page drawer instance: ${instance}`;
      }
      this.instancesByName[instance.name] = instance;
    };

    const unregisterPageDrawer = (name) => {
      if (isDefined(name)) {
        delete this.instancesByName[name];
      }
    };

    const expandPageDrawer = (name) => {
      if (notDefined(this.instancesByName[name])) {
        throw `"${name}" page drawer instance is not registered.`;
      }

      const instance = this.instancesByName[name];
      if (!instance.isExpanded) instance.handleToggle();
    };

    const collapsePageDrawer = (name) => {
      if (notDefined(this.instancesByName[name])) {
        throw `"${name}" page drawer instance is not registered.`;
      }

      const instance = this.instancesByName[name];
      if (instance.isExpanded) instance.handleToggle();
    };

    app.config.globalProperties.$pageDrawer = {
      register(instance) {
        registerPageDrawer(instance);
      },
      unregister(name) {
        unregisterPageDrawer(name);
      },
      expand(name) {
        expandPageDrawer(name);
      },
      collapse(name) {
        collapsePageDrawer(name);
      },
    };
  },
};

export default Plugin;
